// Small formatters shared by the Reports page and the epic summary panel.

// Colours for a Jira status name: a dot for timelines and a pill for badges.
export function statusStyle(status: string): { dot: string; badge: string } {
  const s = (status || '').toLowerCase();
  // Planning statuses before work starts: "Selected for Development" must not read as in progress.
  if (/^(ideation|backlog|selected for development)/.test(s))
    return { dot: 'bg-gray-400', badge: 'bg-gray-100 text-gray-600 ring-gray-200' };
  if (/(done|released|closed|complete|resolved)/.test(s))
    return { dot: 'bg-emerald-500', badge: 'bg-emerald-50 text-emerald-700 ring-emerald-200' };
  if (/(progress|doing|development|building)/.test(s))
    return { dot: 'bg-blue-500', badge: 'bg-blue-50 text-blue-700 ring-blue-200' };
  if (/(review|qa|test|verif)/.test(s))
    return { dot: 'bg-amber-500', badge: 'bg-amber-50 text-amber-700 ring-amber-200' };
  if (/(block|hold|impediment)/.test(s))
    return { dot: 'bg-rose-500', badge: 'bg-rose-50 text-rose-700 ring-rose-200' };
  if (/(to ?do|backlog|open|new|selected)/.test(s))
    return { dot: 'bg-gray-400', badge: 'bg-gray-100 text-gray-600 ring-gray-200' };
  return { dot: 'bg-slate-400', badge: 'bg-slate-50 text-slate-600 ring-slate-200' };
}
